export const RequiredMarker = () => (
  <span className="text-text-error" aria-hidden="true">
    {' *'}
  </span>
);
